class TierEntity {
    constructor(name, farbe, text, bild, vater, mutter) {
        this.name = name;      // Name of the animal
        this.farbe = farbe;    // Color of the animal
        this.text = text;      // Description or bio
        this.bild = bild;      // Image URL or path
        this.vater = vater;
        this.mutter = mutter;
        this.id = name.toLowerCase().replace(/\s+/g, "-");
    }

    getEltern() {
        return [this.vater, this.mutter].filter(Boolean); // Returns only known parents
    }

    getKinder(tierListe) {
        return tierListe.filter(tier => tier.vater === this || tier.mutter === this);
    }
}

export default TierEntity;
